module.exports = __webpack_public_path__ + "assets/img/EIOTBg.d30861f1.png";